import { defineStore } from "pinia";
import Services from '@/services/sutting/ownershipTypesServices'
import { mapList, mapOwnershipType } from '@/helpers/mapFuncs'

export const useOwnershipTypesStore = defineStore("ownershipTypes", {
persist: true,
state:()=>({
    ownershipType: {},
    ownershipTypes: [],
}),
getters : {
    getOwnershipType() {
        return mapOwnershipType(this.ownershipType)
    },
    getOwnershipTypes() {
        return this.ownershipTypes.map(mapOwnershipType)
    },
    getOwnershipTypesList() {
        return this.ownershipTypes.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setOwnershipType(ownershipType) {
        this.ownershipType = ownershipType
    },
    setOwnershipTypes(ownershipTypes) {
        this.ownershipTypes = ownershipTypes
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setOwnershipType(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setOwnershipTypes(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.ownershipTypes.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.ownershipTypes[this.ownershipTypes.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.ownershipTypes = this.ownershipTypes.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
